import { render, staticRenderFns } from "./ExtraFiles.vue?vue&type=template&id=2d9e39cf&scoped=true&"
import script from "./ExtraFiles.vue?vue&type=script&lang=js&"
export * from "./ExtraFiles.vue?vue&type=script&lang=js&"
import style0 from "./ExtraFiles.vue?vue&type=style&index=0&id=2d9e39cf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d9e39cf",
  null
  
)

export default component.exports